import * as ngCore from '@angular/core'
import * as ents from '@attain-apps/entities'

import * as state from '../../../../../../state'

/** Renders a downloadable File Finder entry. */
@ngCore.Component({
  selector: 'atn-file-finder-entry',
  standalone: true,
  styleUrls: ['./component.scss'],
  templateUrl: './component.html',
})
export class Component {
  /** @see {@link state.fileMgmt.Feature} */
  public readonly fileMgmtFeature = ngCore.inject(state.fileMgmt.Feature)

  /** File leaf displayed in this component. */
  public readonly entrySg =
    ngCore.input.required<state.fileMgmt.models.FileTree.Entry>({
      alias: 'entry',
    })

  /** Whether this is the final item in its parent group. */
  public readonly isLastSg = ngCore.input.required<boolean>({
    alias: 'isLast',
  })

  /** Requests a fresh download URL for the selected file. */
  public download(): void {
    const { file } = this.entrySg()
    this.fileMgmtFeature.actions.download
      .from('FileFinder.Entry.Download.Clicked')
      .dispatch({
        ...file,
        purpose: ents.core.common.fileManagement.Purpose.FileManagement,
      })
  }
}
